import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
//import { AnimationService, AnimationBuilder } from 'css-animator';

@Component({
	selector: 'pre-splash',
	templateUrl: './pre-splash.component.html',
	styleUrls: ['./pre-splash.component.scss'],
	standalone: false
})
export class PreSplashComponent implements AfterViewInit {
	//private animator: AnimationBuilder;

	@ViewChild('splash')
	splash: ElementRef;

	constructor(private elementRef: ElementRef) {
		//this.animator = animationService.builder();
	}

	ngAfterViewInit() {
		//setTimeout(() => {
		//    this.animator.setType('fadeOut').hide(this.splash.nativeElement);
		//}, 4000);
	}
}
